/* ============================================
   AUTOMORTA v2 - Warm Retro Terminal JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  // === BLINKING CURSOR on main headings ===
  document.querySelectorAll('h1, .h1').forEach(function(el) {
    if (!el.querySelector('.cursor-char')) {
      const cursor = document.createElement('span');
      cursor.className = 'cursor-char';
      cursor.textContent = '█';
      cursor.style.cssText = 'color:#d45a1a;animation:blink-cursor 1s step-end infinite;margin-left:4px;font-weight:400;';
      el.appendChild(cursor);
    }
  });

  // === TYPEWRITER effect for announcement bar ===
  const announcement = document.querySelector('.announcement-bar__message');
  if (announcement) {
    const text = announcement.textContent.trim();
    announcement.textContent = '';
    let i = 0;
    function type() {
      if (i < text.length) {
        announcement.textContent += text[i];
        i++;
        setTimeout(type, 60);
      }
    }
    setTimeout(type, 500);
  }

  // === HOVER UNDERLINE EFFECT — retro terminal style ===
  document.querySelectorAll('.card-wrapper').forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      this.style.boxShadow = '4px 4px 0 #b8b2a5';
    });
    card.addEventListener('mouseleave', function() {
      this.style.boxShadow = 'none';
    });
  });

});
